var _circle, _path, _line, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 66,
    viewBox: "0 0 264 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#478F96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2239 39V36.86H32.0639V26.94H31.8839L28.8439 30.54L27.2039 29.16L30.6639 25.04H34.6439V36.86H37.8439V39H28.2239Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83.9896,
    y1: 32.5001,
    x2: 179.99,
    y2: 31.5001,
    stroke: "#478F96",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 33,
    r: 32.5,
    fill: "white",
    stroke: "#478F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.324 40H225.644V37.56L230.024 33.72C230.771 33.0667 231.317 32.48 231.664 31.96C232.011 31.4267 232.184 30.8533 232.184 30.24V29.98C232.184 29.3667 231.984 28.9 231.584 28.58C231.184 28.2467 230.697 28.08 230.124 28.08C229.404 28.08 228.857 28.2867 228.484 28.7C228.111 29.1 227.844 29.5867 227.684 30.16L225.404 29.28C225.551 28.8133 225.757 28.3733 226.024 27.96C226.291 27.5333 226.624 27.16 227.024 26.84C227.437 26.52 227.917 26.2667 228.464 26.08C229.011 25.8933 229.637 25.8 230.344 25.8C231.077 25.8 231.731 25.9067 232.304 26.12C232.877 26.32 233.357 26.6067 233.744 26.98C234.144 27.3533 234.444 27.7933 234.644 28.3C234.857 28.8067 234.964 29.36 234.964 29.96C234.964 30.5467 234.871 31.08 234.684 31.56C234.497 32.04 234.244 32.5 233.924 32.94C233.604 33.3667 233.231 33.78 232.804 34.18C232.377 34.5667 231.924 34.96 231.444 35.36L228.504 37.78H235.324V40Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.acb49e17537c63f6cbdbd9204d129e78.svg";
export { ForwardRef as ReactComponent };